module.exports = __webpack_public_path__ + "static/img/download.97d8f4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/download.png
// module id = dFH8
// module chunks = 0